import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import api from "../../config.json";
import CountUp from "react-countup";
import moment from "moment";
import Gauge from "react-gauge-component";
import { Chart } from "react-google-charts";
import Table from "../../Common/table";
import Tooltip from "../../utill/tooltip";

// localStorage key shared with the Navbar Equipment Group filter
const EQUIP_GROUP_FILTER_KEY = "dashboardEquipmentGroupFilter";

// Build the request body, including the selected Equipment Group names (array)
// when any are selected. Empty selection means "All" -> no filter sent.
const buildEquipGroupPayload = (storageKey = EQUIP_GROUP_FILTER_KEY) => {
  let groups = [];
  try {
    const raw = localStorage.getItem(storageKey);
    const parsed = raw ? JSON.parse(raw) : [];
    groups = Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    groups = [];
  }
  return groups.length > 0 ? { EquipmentGroup: groups } : {};
};

const DashBoardDowntimeAndIncident = ({ spncolorconfig, getCurrentData, equipmentGroupFilter, filterStorageKey = EQUIP_GROUP_FILTER_KEY }) => {
  const [Strokes, setStrokes] = useState(null);
  const [equipmentColor, setEquipmentColor] = useState({ EquipmentColor: [] });
  const [sortColumn, setSortColumn] = useState({ path: "From", order: "asc" });
  const [thisMonthApiData, setThisMonthApiData] = useState([]);
  const [currentApiData, setCurrentApiData] = useState([]);
  const [data, setdata] = useState([]);
  const [data1, setdata1] = useState([]);

  const [currentPlantChart, setCurrentPlantChart] = useState([]);

  const [monthPlantChart, setMonthPlantChart] = useState([]);
  // const data = ;

  const currentShiftLable = `${
    currentApiData && currentApiData.length > 0
      ? moment().format("DD-MM-YY")
      : "No Shift"
  } / ${
    currentApiData && currentApiData.length > 0
      ? currentApiData[0].Shift
      : "No Shift"
  }`;
  const thisMonthLabel = `${moment().format("MMM YYYY")}`;

  const columns = [
    { path: "EquipmentGroup", label: "Group" },
    { path: "MachineRunCurrent", label: currentShiftLable },
    { path: "MachineRunMonth", label: thisMonthLabel },
  ];
  // ,content: (obj) => <label>{moment(obj.From).format('MMMM')}</label>
  // ,content: (obj) => <label>{moment(obj.From).format('MMMM')}</label>
  const columns1 = [
    { path: "EquipmentGroup", label: "Group" },
    { path: "AvgSPMCurrent", label: currentShiftLable },
    { path: "AvgSPMMonth", label: thisMonthLabel },
  ];
  const columns2 = [
    { path: "EquipmentGroup", label: "Group" },
    { path: "PerformanceCurrent", label: currentShiftLable },
    { path: "PerformanceMonth", label: thisMonthLabel },
  ];

  console.log(spncolorconfig, "eviunr");

  const options = {
    //  title: "This Shift",
    //  subtitle: "Sales, Expenses: 2014-2017",
    chartArea: {
      width: "75%",
      // height: '80%',
      left: 100,
      top: 40,
    },
    hAxis: {
      //  title: "Machine (Current Shift)",
      minValue: 0,
      slantedText: true,
      slantedTextAngle: 90,
      fontSize: 14, // Adjust as needed
      bold: true,
      titleTextStyle: {
        italic: false, // Ensures italic is off
        fontSize: 14, // Adjust as needed
        bold: true,
      },
    },
    vAxes: {
      0: { title: "Duration ( In mins )" },
      1: { title: "Incident Count" },
    },
    seriesType: "bars",
    series: {
      0: { targetAxisIndex: 0, color: "#1f77b4" },
      1: { targetAxisIndex: 1, color: "#ff7f0e" },
    },
    animation: {
      duration: 1000,
      easing: "out",
    },
    bar: {
      groupWidth: "75%",
    },
  };

  const options1 = {
    //  title: "This Month",
    // subtitle: "Sales, Expenses: 2014-2017",
    chartArea: {
      width: "75%",
      // height: '80%',
      left: 100,
      top: 40,
    },
    hAxis: {
      //title: "Machine (This Month)",
      minValue: 0,
      slantedText: true,
      slantedTextAngle: 90,
      fontSize: 14, // Adjust as needed
      bold: true,

      titleTextStyle: {
        italic: false, // Ensures italic is off
        fontSize: 14, // Adjust as needed
        bold: true, // Ensures bold
        slantedText: true, // Enables slanted text
        slantedTextAngle: 90, // Sets slant angle
      },
    },
    vAxes: {
      0: { title: "Duration ( In mins )" },
      1: { title: "Incident Count" },
    },
    seriesType: "bars",
    series: {
      0: { targetAxisIndex: 0, color: "#1f77b4" },
      1: { targetAxisIndex: 1, color: "#ff7f0e" },
    },
    animation: {
      duration: 1000,
      easing: "out",
    },
    bar: {
      groupWidth: "75%",
    },
  };

  const chartOption = {
    // subtitle: "Sales, Expenses: 2014-2017",

    vAxes: {
      0: { title: "Duration ( In mins )" },
    },
    legend: {
      position: "none",
    },
  };

  const handleSort = (sortColumn) => {
    // if (productionData.length > 0) {
    //   const sorted = _.orderBy(
    //     productionData,
    //     [sortColumn.path],
    //     [sortColumn.order]
    //   );
    //   setProductionData(sorted)
    setSortColumn(sortColumn);
    // }
  };
  useEffect(() => {
    // Initial fetch of data
    getCurrentShiftData();
    getCurrenMonthData();

    // Schedule the next API call
    // scheduleNextCall re-arms itself, so keep the latest timer id in a handle unmount can cancel.
    const timer = { id: null, cancelled: false };
    scheduleNextCall(timer);

    // Clean up the timer when component unmounts
    return () => {
      timer.cancelled = true;
      clearTimeout(timer.id);
    };
  }, []);

  // Refetch whenever the Equipment Group filter (controlled from the Navbar
  // header) changes. Skip the first run since the mount effect already fetches.
  const isFirstFilterRun = useRef(true);
  useEffect(() => {
    if (isFirstFilterRun.current) {
      isFirstFilterRun.current = false;
      return;
    }
    getCurrentShiftData();
    getCurrenMonthData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(equipmentGroupFilter || [])]);

  function scheduleNextCall(timer) {
    const now = new Date();
    let delay;

    // Calculate delay until the next desired time (next multiple of 5 minutes)
    const minutes = now.getMinutes();
    const nextMultiple = Math.ceil(minutes / 5) * 5; // Calculate the next multiple of 5 minutes
    const targetTime = new Date(now);
    targetTime.setMinutes(nextMultiple, 0, 0); // Set the target time to the next multiple of 5 minutes

    if (targetTime <= now) {
      targetTime.setMinutes(targetTime.getMinutes() + 5); // If target time is past, schedule for the next multiple of 5 minutes
    }

    delay = targetTime.getTime() - now.getTime();

    // Schedule the next API call recursively
    timer.id = setTimeout(function () {
      if (timer.cancelled) return;
      getCurrenMonthData();
      getCurrentShiftData();
      scheduleNextCall(timer);
    }, delay);
  }

  const getCurrentShiftData = () => {
    axios
      .put(api.dataEntryUrl + "GetPlantDashboard_CurrentShift", buildEquipGroupPayload(filterStorageKey))
      .then((response) => {
        if (response.status === 200) {
          const totalStrokes = response.data
            .map((item) => Number(item.Cycles))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );
          const ChartData = response.data.flatMap((item) =>
            item.DowntimeIncidents.map((one) => [
              one.Equipment,
              one.Incidents.Duration,
              one.Incidents.Incident,
            ])
          );

          ChartData.unshift([
            "machine",
            "Downtime Duration (In mins)",
            "Incident Count",
          ]);

          const runtime = response.data
            .map((item) => Number(item.RunTime))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );

          const downs = response.data
            .map((item) => Number(item.Downtime))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );

          const breaks = response.data
            .map((item) => Number(item.Break))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );

          const plant = [
            [
              "Parameter",
              "Duration (In Mins)",
              { role: "style" },
              { role: "annotation" },
            ],
            ["Runtime", runtime, "green", runtime],
            ["Downtime", downs, "red", downs],
            ["Breaks", breaks, "yellow", breaks],
          ];
          setCurrentPlantChart(plant);
          getCurrentData(new Date());
          setStrokes(totalStrokes);
          setCurrentApiData(response.data);
          setdata(ChartData);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const getCurrenMonthData = () => {
    axios
      .put(api.dataEntryUrl + "GetPlantDashboard_CurrentMonth", buildEquipGroupPayload(filterStorageKey))
      .then((response) => {
        console.log(response, "success response for the dashboard");
        if (response.status === 200) {
          // const totalStrokes = response.data
          //   .map((item) => Number(item.Cycles))
          //   .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          const ChartData = response.data.flatMap((item) =>
            item.DowntimeIncidents.map((one) => [
              one.Equipment,
              one.Incidents.Duration,
              one.Incidents.Incident,
            ])
          );

          ChartData.unshift([
            "machine",
            "Downtime Duration (In mins)",
            "Incident Count",
          ]);

          const runtime = response.data
            .map((item) => Number(item.RunTime))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );

          const downs = response.data
            .map((item) => Number(item.TotalDowntimeDuration))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );

          const breaks = response.data
            .map((item) => Number(item.Break))
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0
            );

          const plant = [
            [
              "Parameter",
              "Duration (In Mins)",
              { role: "style" },
              { role: "annotation" },
            ],
            ["Runtime", runtime, "green", runtime],
            ["Downtime", downs, "red", downs],
            ["Breaks", breaks, "yellow", breaks],
          ];
          setMonthPlantChart(plant);
          // getCurrentData(new Date())
          // setStrokes(totalStrokes)
          setThisMonthApiData(response.data);
          setdata1(ChartData);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  // useEffect(() => {
  //   console.log('called aunction after one time')

  //   const checkTimeAndFetch = () => {
  //     const now = new Date();
  //     const minutes = now.getMinutes();

  //     if (minutes % 5 === 0) {
  //       console.log('function called  for multiple of 2', minutes % 5 === 0)
  //       axios.put(api.dataEntryUrl + 'GetPlantDashboard_CurrentShift')
  //         .then((response) => {
  //           console.log(response, "success response for the dashboard");
  //           if (response.status === 200) {
  //             const totalStrokes = response.data
  //               .map((item) => Number(item.Cycles))
  //               .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  //             const ChartData = response.data
  //               .flatMap(item => item.DowntimeIncidents.map(one => [
  //                 one.Equipment,
  //                 one.Incidents.Duration,
  //                 one.Incidents.Incident
  //               ]));

  //             console.log(ChartData);

  //             console.log(ChartData, "ukfufuy", totalStrokes);
  //             ChartData.unshift(["machine", "Downtime", "Incident"])

  //             setStrokes(totalStrokes)
  //             setCurrentApiData(response.data)
  //             setdata(ChartData)

  //           }
  //         })
  //         .catch(error => console.error('Error:', error));

  //       // axios.put(api.dataEntryUrl + 'GetPlantDashboard_2')
  //       //   .then((response) => {
  //       //     if (response.status === 200) {
  //       //       console.log(response.data, "ksvksvksnkjkjd");
  //       //       const ChartData = response.data
  //       //         .flatMap(item => item.DowntimeIncidents.map(one => [
  //       //           one.Equipment,
  //       //           one.Incidents.Duration,
  //       //           one.Incidents.Incident
  //       //         ]));

  //       //       console.log(ChartData);

  //       //       ChartData.unshift(["machine", "Downtime", "Incident"])
  //       //       setdata1(ChartData)
  //       //       // getCurrentData({ CurrentDate: response.data.CurrentDate })
  //       //       // setAvgSPM(response.data);
  //       //     }
  //       //   })
  //       //   .catch(error => console.error('Error:', error));

  //     }
  //   };

  //   // Initial check and fetch
  //   checkTimeAndFetch();

  //   // Check time every minute and fetch if it's a multiple of 5
  //   const interval = setInterval(checkTimeAndFetch, 30 * 1000);

  //   // Clean up interval on component unmount
  //   return () => clearInterval(interval);
  // }, []);

  // useEffect(() => {
  //   // Function to call the API
  //   const callApi = (interval, data) => {
  //     console.log(`Calling API after ${interval / 1000} seconds with data:`, data);
  //     // Replace the URL with your API endpoint
  //     axios.put(api.dataEntryUrl + 'GetPlantDashboard_1')
  //       .then((response) => {
  //         console.log(response, "success response for the dashboard");
  //         if (response.status === 200) {

  //           const totalStrokes = response.data
  //             .map((item) => item.Strokes)
  //             .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

  //           setStrokes(totalStrokes)
  //           setapidata(response.data)
  //           // if (data === "MachineRun") {
  //           //   getCurrentData({ CurrentDate: response.data.CurrentDate })
  //           //   setMachineRun(response.data.MachineRun);

  //           // }
  //           // if (data === "Strokes") {
  //           //   getCurrentData({ CurrentDate: response.data.CurrentDate })
  //           //   setStrokes(response.data);
  //           //   setStrokesDate(response.data.Date);

  //           // }
  //           // if (data === "AvgSPM") {
  //           //   getCurrentData({ CurrentDate: response.data.CurrentDate })
  //           //   setAvgSPM(response.data);
  //           // }
  //           // if (data === "RunningSPM") {
  //           //   getCurrentData({ CurrentDate: response.data.CurrentDate })
  //           //   setRunningSPM(response.data)
  //           // }
  //           // if (data === "EquipmentColor") {
  //           //   getCurrentData({ CurrentDate: response.data.CurrentDate })
  //           //   setEquipmentColor(response.data)
  //           // }
  //         }
  //       })
  //       .catch(error => console.error('Error:', error));
  //   };

  //   // Set intervals to call API independently
  //   const intervals = [
  //     // { interval: 180000, data: 'MachineRun' },  // 5s
  //     { interval: 600000, data: 'Stroke' },    // 10s
  //     { interval: 600000, data: 'AvgSPM' },
  //     { interval: 600000, data: 'RunningSPM' },
  //     { interval: 180000, data: 'EquipmentColor' }      // 15s
  //   ];

  //   // Store the interval IDs so they can be cleared if needed
  //   const intervalIds = intervals.map((call) => {
  //     return setInterval(() => callApi(call.interval, call.data), call.interval);
  //   });

  //   // Cleanup function to clear intervals when component unmounts
  //   return () => {
  //     intervalIds.forEach((id) => clearInterval(id));
  //   };
  // }, []);

  const getPercentage = () => {
    const equipColors = { ...equipmentColor };
    let per = 0;

    const greens = equipColors.EquipmentColor.filter((x) => x.Color == "green");
    per = (greens.length / equipColors.EquipmentColor.length) * 100;
    if (isNaN(per) && !isFinite(per)) {
      per = 0;
    }
    return per.toFixed(1);
  };

  const getMacRunData = () => {
    const data = [...thisMonthApiData];
    const data1 = [...currentApiData];
    const arr = [];
    data.forEach((x, i) => {
      const obj = {
        EquipmentGroup: x.EquipmentGroup,
        MachineRunMonth: x.MachineRun,
      };
      if (data1[i]) {
        obj["MachineRunCurrent"] = data1[i].MachineRun;
      }
      arr.push(obj);
    });
    return arr;
  };

  const getAvgSPmData = () => {
    const data = [...thisMonthApiData];
    const data1 = [...currentApiData];
    const arr = [];
    data.forEach((x, i) => {
      const obj = { EquipmentGroup: x.EquipmentGroup, AvgSPMMonth: x.AvgSPM };
      if (data1[i]) {
        obj["AvgSPMCurrent"] = data1[i].AvgSPM;
      }
      arr.push(obj);
    });
    return arr;
  };
  const getPerformanData = () => {
    const data = [...thisMonthApiData];
    const data1 = [...currentApiData];
    const arr = [];
    data.forEach((x, i) => {
      const obj = {
        EquipmentGroup: x.EquipmentGroup,
        PerformanceMonth: x.Performance,
      };
      if (data1[i]) {
        obj["PerformanceCurrent"] = data1[i].Performance;
      }
      arr.push(obj);
    });
    return arr;
  };

  return (
    <>
      {/* <div>
       
        <div className="container1">
          <div className="grid-item1 grid-item-40">
            <div className="vertical-container">
              <div className="vertical-item ">
                <div
                  style={{ fontWeight: "700", fontSize: "25px" }}
                  className="text-center "
                >
                  Total Strokes ({" "}
                  {currentApiData && currentApiData.length > 0
                    ? moment().format("DD-MM-YY")
                    : "not available"}{" "}
                  /{" "}
                  {currentApiData && currentApiData.length > 0
                    ? currentApiData[0].Shift
                    : "not available"}
                  ) <br />
                  <p
                    style={{
                      color: "green",
                      fontWeight: "700",
                      fontSize: "30px",
                    }}
                  >
                    <CountUp end={Strokes && (Strokes ?? 0)} duration={4} />
                  </p>
                </div>
              </div>
              <div className="vertical-item shadow d-flex flex-column custom-dash-table">
                <div style={{ width: "100%" }}>
                  <div className="d-flex justify-content-center ">
                    <h3 className="text-center ">Machine Running (%) </h3>
                    <Tooltip text="Machine Run =( Run Time / Shift Time -Breaks )">
                      <button
                        className=" fw-bolder m-1 position-absolute right-3 rounded-circle   d-flex justify-content-center align-items-center text-white shadow"
                        style={{
                          width: "20px",
                          backgroundColor: "grey",
                          height: "20px",
                          border: "none",
                          padding: "0",
                        }}
                      >
                        !
                      </button>
                    </Tooltip>
                  </div>
                  <div className="">
                    {
                      <Table
                        id="BenchMark"
                        columns={columns}
                        data={getMacRunData()}
                        onSort={handleSort}
                        sortColumn={sortColumn}
                        search={true}
                      />
                    }
                  </div>
                </div>
                <div style={{ width: "100%" }}>
                  <div className="d-flex justify-content-center ">
                    <h3 className="text-center">Average SPM</h3>
                    <Tooltip text="Avg SPM =( Total Strokes / RunTime + DownTime )">
                      <button
                        className=" fw-bolder m-1 position-absolute right-3 rounded-circle   d-flex justify-content-center align-items-center text-white shadow"
                        style={{
                          width: "20px",
                          backgroundColor: "grey",
                          height: "20px",
                          border: "none",
                          padding: "0",
                        }}
                      >
                        !
                      </button>
                    </Tooltip>
                  </div>

                  {
                    <Table
                      id="BenchMark"
                      columns={columns1}
                      data={getAvgSPmData()}
                      onSort={handleSort}
                      sortColumn={sortColumn}
                      search={true}
                    />
                  }
                </div>
                <div style={{ width: "100%" }}>
                  <div className="d-flex justify-content-center ">
                    <h3 className="text-center"> Performance (%)</h3>

                    <Tooltip text="Performance = Total Strokes/(ShiftTime -Breaks) * Ideal Spm">
                      <button
                        className=" fw-bolder m-1 position-absolute right-3 rounded-circle   d-flex justify-content-center align-items-center text-white shadow"
                        style={{
                          width: "20px",
                          backgroundColor: "grey",
                          height: "20px",
                          border: "none",
                          padding: "0",
                        }}
                      >
                        !
                      </button>
                    </Tooltip>
                  </div>

                  {
                    <Table
                      id="BenchMark"
                      columns={columns2}
                      data={getPerformanData()}
                      onSort={handleSort}
                      sortColumn={sortColumn}
                      search={true}
                    />
                  }
                </div>
              </div>
            </div>
          </div>

          <div className=" grid-item-60">
            <h4 className="common-heading">
              Downtime Duration / Incident Count (
              {currentApiData && currentApiData.length > 0
                ? moment().format("DD-MM-YY")
                : "not available"}{" "}
              /{" "}
              {currentApiData && currentApiData.length > 0
                ? currentApiData[0].Shift
                : "not available"}
              )
            </h4>
            {data.length > 0 ? (
              <Chart
                chartType="ComboChart"
                width="100%"
                height={300}
                data={data}
                options={options}
              />
            ) : (
              <p className="text-center">
                No Current Shift Exist / Data Not Available
              </p>
            )}
            <h4 className="common-heading">
              Downtime Duration / Incident Count (
              {thisMonthApiData && thisMonthApiData.length > 0
                ? moment().format("MMM YYYY")
                : "not available"}
              )
            </h4>
            {data1.length > 0 ? (
              <Chart
                className="mt-4"
                chartType="ComboChart"
                width="100%"
                height={300}
                data={data1}
                options={options1}
              />
            ) : (
              <p className="text-center">This Month Data Not Available</p>
            )}
          </div>
        </div>
        <div className="container1 border">
          <div className=" grid-item-60">
            <h4 className="common-heading text-center">This Month ({thisMonthLabel})</h4>
            {monthPlantChart.length > 0 && (
              <Chart
                chartType="ColumnChart"
                width="100%"
                height={300}
                data={monthPlantChart}
                options={{
                  //  title: `This Month (${thisMonthLabel})`,
                  ...chartOption,
                }}
              />
            )}
          </div>
          <div className=" grid-item-60">
            <h4 className="common-heading text-center">This Shift ({currentShiftLable})</h4>
            {currentPlantChart.length > 0 && (
              <Chart
                chartType="ColumnChart"
                width="100%"
                height={300}
                data={currentPlantChart}
                options={{
                  // title: `This Shift (${currentShiftLable})`,
                  ...chartOption,
                }}
                // options={options}
              />
            )}
          </div>
        </div>
       
      </div> */}
      <div className="container-fluid min-vh-100 p-1 d-flex flex-column flex-md-row gap-3 bg-light">
        {/* Left Column (30%) */}
        <div className="col-12 col-md-4 d-flex flex-column gap-1 p-1 h-md-100">
          {/* Metric Cards */}
          <div className="card shadow-sm flex-grow-1">
            <div className="card-body p-1">
            <div className="vertical-container">
              <div className="vertical-item ">
                <div
                  style={{ fontWeight: "700", fontSize: "30px" }}
                  className="text-center "
                >
                  Total Strokes ({" "}
                  {currentApiData && currentApiData.length > 0
                    ? moment().format("DD-MM-YY")
                    : "not available"}{" "}
                  /{" "}
                  {currentApiData && currentApiData.length > 0
                    ? currentApiData[0].Shift
                    : "not available"}
                  ) <br />
                  <p
                    style={{
                      color: "green",
                      fontWeight: "700",
                      fontSize: "35px",
                    }}
                  >
                    {/* {Strokes} */}
                    <CountUp end={Strokes && (Strokes ?? 0)} duration={4} />
                  </p>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className="card shadow-sm flex-grow-1">
            <div className="card-body p-1">
              <div style={{ width: "100%" }}>
                <div className="d-flex justify-content-center align-items-center position-relative">
                  <h3 className="text-center mb-0">Machine Running (%)</h3>
                  <Tooltip text="Machine Run = (Run Time / (Shift Time - Breaks)) * 100">
                    <button
                      className="fw-bolder ms-2 rounded-circle d-flex justify-content-center align-items-center text-white shadow"
                      style={{
                        width: "20px",
                        backgroundColor: "grey",
                        height: "20px",
                        border: "none",
                        padding: "0",
                      }}
                    >
                      i
                    </button>
                  </Tooltip>
                </div>
                <div className="">
                  {
                    <Table
                      id="BenchMark"
                      columns={columns}
                      data={getMacRunData()}
                      onSort={handleSort}
                      sortColumn={sortColumn}
                      search={true}
                    />
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="card shadow-sm flex-grow-1">
            <div className="card-body p-1">
              <div style={{ width: "100%" }}>
                <div className="d-flex justify-content-center align-items-center position-relative">
                  <h3 className="text-center mb-0">Average SPM</h3>
                  <Tooltip text="Avg SPM = Total Strokes / (Run Time + Down Time)">
                    <button
                      className="fw-bolder ms-2 rounded-circle d-flex justify-content-center align-items-center text-white shadow"
                      style={{
                        width: "20px",
                        backgroundColor: "grey",
                        height: "20px",
                        border: "none",
                        padding: "0",
                      }}
                    >
                      i
                    </button>
                  </Tooltip>
                </div>

                {
                  <Table
                    id="BenchMark"
                    columns={columns1}
                    data={getAvgSPmData()}
                    onSort={handleSort}
                    sortColumn={sortColumn}
                    search={true}
                  />
                }
              </div>
            </div>
          </div>
          <div className="card shadow-sm flex-grow-1">
            <div className="card-body p-1">
              <div style={{ width: "100%" }}>
                <div className="d-flex justify-content-center align-items-center position-relative">
                  <h3 className="text-center mb-0">Performance (%)</h3>
                  <Tooltip text="Performance = (Total Strokes / ((Shift Time - Breaks) * Ideal SPM)) * 100">
                    <button
                      className="fw-bolder ms-2 rounded-circle d-flex justify-content-center align-items-center text-white shadow"
                      style={{
                        width: "20px",
                        backgroundColor: "grey",
                        height: "20px",
                        border: "none",
                        padding: "0",
                      }}
                    >
                      i
                    </button>
                  </Tooltip>
                </div>

                {
                  <Table
                    id="BenchMark"
                    columns={columns2}
                    data={getPerformanData()}
                    onSort={handleSort}
                    sortColumn={sortColumn}
                    search={true}
                  />
                }
              </div>
            </div>
          </div>
        </div>

        {/* Right Column (70%) */}
        <div className="col-12 col-md-8 d-flex flex-column gap-1 p-1 h-md-100">
          {/* Top Section (Chart) */}
          <div className="card shadow-sm flex-grow-1">
            <div className="card-body">
                <h4 className="common-heading text-center">
                  Downtime Duration / Incident Count (
                  {currentApiData && currentApiData.length > 0
                    ? moment().format("DD-MM-YY")
                    : "not available"}{" "}
                  /{" "}
                  {currentApiData && currentApiData.length > 0
                    ? currentApiData[0].Shift
                    : "not available"}
                  )
                </h4>
                {data.length > 0 ? (
                  <Chart
                    chartType="ComboChart"
                    width="100%"
                    height={300}
                    data={data}
                    options={options}
                  />
                ) : (
                  <p className="text-center">
                    No Current Shift Exist / Data Not Available
                  </p>
                )}
               
            </div>
          </div>

          {/* Bottom Section (Table) */}
          <div className="card shadow-sm flex-grow-1">
            <div className="card-body">
            <h4 className="common-heading text-center">
                  Downtime Duration / Incident Count (
                  {thisMonthApiData && thisMonthApiData.length > 0
                    ? moment().format("MMM YYYY")
                    : "not available"}
                  )
                </h4>
                {data1.length > 0 ? (
                  <Chart
                    className="mt-4"
                    chartType="ComboChart"
                    width="100%"
                    height={300}
                    data={data1}
                    options={options1}
                  />
                ) : (
                  <p className="text-center">This Month Data Not Available</p>
                )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-md-12 d-flex flex-column gap-1 p-1 h-md-100">
      <div className="card shadow-sm flex-grow-1">
      <div className="card-body d-flex">

          <div className=" grid-item-60">
            <h4 className="common-heading text-center">This Month ({thisMonthLabel})</h4>
            {monthPlantChart.length > 0 && (
              <Chart
                chartType="ColumnChart"
                width="100%"
                height={300}
                data={monthPlantChart}
                options={{
                  //  title: `This Month (${thisMonthLabel})`,
                  ...chartOption,
                }}
              />
            )}
          </div>
          <div className=" grid-item-60">
            <h4 className="common-heading text-center">This Shift ({currentShiftLable})</h4>
            {currentPlantChart.length > 0 && (
              <Chart
                chartType="ColumnChart"
                width="100%"
                height={300}
                data={currentPlantChart}
                options={{
                  // title: `This Shift (${currentShiftLable})`,
                  ...chartOption,
                }}
                // options={options}
              />
            )}
          </div>
        </div>
      </div>
      </div>
    
    </>
  );
};

export default DashBoardDowntimeAndIncident;
